console.log("%conload.js loaded: ", "background-color: pink; color: black;")

const handlesElement = document.querySelector('.related-handles')

let relatedVariantHandles = "";

if (handlesElement) {
    relatedVariantHandles = handlesElement.getAttribute('data-handles')
} else {
    relatedVariantHandles = ""
}

const relatedVariantHandlesArray = relatedVariantHandles.trim().replaceAll("\n", '').split(" ").filter(handle => handle !== "")

let variantIdsArray = [];

console.log("relatedVariantHandlesArray: ", relatedVariantHandlesArray)

const getVariantIds = async (relatedVariantHandlesArray) => {
    for (const handle of relatedVariantHandlesArray) {
        const response = await fetch(handle + '.json')
        const data = await response.json()
        for (const variant of data.product.variants) {
            variantIdsArray.push(variant.id)
        }
    }

    console.log("FINISHED")
    console.log("variantIdsArray: ", variantIdsArray)
    console.log("JSON.parse(localStorage.getItem('shopify-edit-state'))[1]: ", Number(JSON.parse(localStorage.getItem("shopify-edit-state"))?.[1]))

    const currentVariantId = Number(JSON.parse(localStorage.getItem("shopify-edit-state"))?.[1])

    console.log("currentVariantId: ", currentVariantId)

    console.log("variantIdsArray.includes(currentVariantId): ", variantIdsArray.includes(currentVariantId))

    if (!variantIdsArray.includes(currentVariantId)) {
        console.log("%ccurrent variant is not from edited cart item", "background-color: red; color: black;")
        localStorage.setItem('shopify-nav-from-edit', false)
        localStorage.removeItem('shopify-edit-state')
    } else {
        console.log("%ccurrent variant is from edited cart item", "background-color: lime; color: black;")
    }
}

getVariantIds(relatedVariantHandlesArray)

if ($('.mobile-quad-video').length) {
    $('.mobile-quad-video').attr('playsinline', '');
    $('.mobile-quad-video')[0].load();
    $('.mobile-quad-video')[0].play();
    $('.mobile-quad-video').on('loadeddata', function() {
        setTimeout(function() {
            $('.mobile-quad-video').css('visibility', 'visible')
        }, 100);
    });
}